<template>
  <div class="col-start-1 col-end-13">
    <div
      class=" p-3 rounded-lg"
      v-if="thread.type != 'lineItem'"
      :class="[
        thread.type === 'customer'
          ? 'col-start-1 col-end-8'
          : 'col-start-6 col-end-13'
      ]"
    >
      <div
        class="flex flex-row items-center"
        :class="[
          thread.type === 'message' ? 'justify-start flex-row-reverse' : ''
        ]"
      >
        <div
          class="flex items-center justify-center h-8 w-8 rounded-full bg-indigo-500 flex-shrink-0 text-white"
        >
          {{ getFirstCharacter(thread) }}
        </div>
        <div
          class="relative text-xs bg-white py-2 px-4 shadow rounded-md text-gray-800"
          :class="[thread.type === 'message' ? 'mr-3' : 'ml-3']"
        >
          <div class="text-right text-gray-400 text-xs">
            {{ thread.createdAt | messageTime }}
          </div>
          <p v-html="thread.body" v-linkified></p>

          <div v-if="thread.attachments">
            <AttachmentItem
              v-for="(attachment, index) of thread.attachments"
              :key="index"
              :attachment="attachment"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <span
        class="text-xs text-cool-gray-700 pb-4"
        v-html="getLineItemText(thread)"
      />
    </div>
  </div>
</template>

<script>
import AttachmentItem from "./AttachmentItem";

export default {
  components: {
    AttachmentItem
  },
  props: {
    thread: {
      type: Object,
      required: true
    },
    conversation: {
      type: Object
    }
    // customer: {
    //   type: Object,
    //   required: true
    // }
  },
  created() {
    if (this.thread.type === "customer") {
      this.$emit("markAsRead", this.thread.id);
    }
  },
  methods: {
    getLineItemText(thread) {
      let creator = "";
      creator = this.$store.getters["Inbox/getUserNameById"](thread.createdBy);
      switch (thread.actionType) {
        case "assignedTo":
          return `<span class="h7">${creator} assigned to</span>  ${this.$store.getters[
            "Inbox/getUserNameById"
          ](thread.assignedTo)}`;
        case "ended":
          return thread.actionSource.endedBy === "customer"
            ? "Customer ended the chat"
            : "Agent ended the chat";
        default:
          return "";
      }
    },
    getFirstCharInStr(str) {
      return str.charAt(0);
    },
    getFirstCharacter(thread) {
      if (thread.type === "customer") {
        return this.getFirstCharInStr(this.conversation.customer.firstName);
      }
      let creator = this.$store.getters["Inbox/getUserNameById"](
        thread.createdBy
      );
      return this.getFirstCharInStr(creator);
    }
  }
};
</script>

<style lang="scss" scoped></style>
